<template>
  <div class="contract-page">
    <b-container fluid class="px-4 py-4">

      <!-- Page Title -->
      <div class="page-title-bar">
        <b-icon icon="telephone-fill" class="mr-2"></b-icon>
        {{ $t('HomePage.contract') }}
      </div>

      <b-row class="mt-4">

        <!-- Contact card -->
        <b-col md="5" class="mb-4">
          <div class="contact-card">
            <div class="contact-card-header">
              <b-icon icon="building" class="mr-2"></b-icon>ກົມກົງສຸນ
            </div>
            <div class="contact-card-body">
              <div class="contact-item">
                <div class="contact-icon-wrap">
                  <b-icon icon="geo-alt-fill"></b-icon>
                </div>
                <div>
                  <div class="contact-label">ທີ່ຢູ່</div>
                  <div class="contact-value">23 ຖະໜົນສິງຫາ, ບ້ານໂພນສະຫວ່າງ, ເຂດໄຊເສດຖາ, ນະຄອນຫຼວງວຽງຈັນ</div>
                </div>
              </div>

              <div class="contact-item">
                <div class="contact-icon-wrap contact-icon-green">
                  <b-icon icon="telephone-fill"></b-icon>
                </div>
                <div>
                  <div class="contact-label">ໂທລະສັບ</div>
                  <div class="contact-value">021 254 176</div>
                </div>
              </div>

              <div class="contact-item">
                <div class="contact-icon-wrap contact-icon-purple">
                  <b-icon icon="printer-fill"></b-icon>
                </div>
                <div>
                  <div class="contact-label">ແຟັກ</div>
                  <div class="contact-value">021 243 462</div>
                </div>
              </div>

              <div class="contact-item">
                <div class="contact-icon-wrap contact-icon-red">
                  <b-icon icon="envelope-fill"></b-icon>
                </div>
                <div>
                  <div class="contact-label">ອີເມວ</div>
                  <a href="mailto:consular@mofa.gov.la" class="contact-value contact-link">consular@mofa.gov.la</a>
                </div>
              </div>

              <div class="contact-item">
                <div class="contact-icon-wrap contact-icon-teal">
                  <b-icon icon="globe"></b-icon>
                </div>
                <div>
                  <div class="contact-label">ເວັບໄຊທ໌</div>
                  <a href="https://www.consularlao.gov.la" target="_blank" class="contact-value contact-link">www.consularlao.gov.la</a>
                </div>
              </div>
            </div>
          </div>
        </b-col>

        <!-- Office hours + Map placeholder -->
        <b-col md="7" class="mb-4">

          <!-- Office hours card -->
          <div class="info-card mb-4">
            <div class="info-card-header">
              <b-icon icon="clock-fill" class="mr-2"></b-icon>ເວລາທຳການ
            </div>
            <div class="info-card-body">
              <b-row>
                <b-col cols="6">
                  <div class="hours-block">
                    <div class="hours-day-label">ຈັນ – ສຸກ</div>
                    <div class="hours-time-label">08:00 – 12:00</div>
                    <div class="hours-time-label">13:00 – 16:00</div>
                  </div>
                </b-col>
                <b-col cols="6">
                  <div class="hours-block closed-block">
                    <div class="hours-day-label">ເສົາ – ອາທິດ</div>
                    <div class="hours-time-closed">ວັນໝົດ / ປິດ</div>
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>

          <!-- Quick service links -->
          <div class="info-card">
            <div class="info-card-header">
              <b-icon icon="lightning-fill" class="mr-2"></b-icon>ການບໍລິການດ່ວນ
            </div>
            <div class="info-card-body p-0">
              <b-row class="m-0">
                <b-col cols="6" class="p-0">
                  <router-link to="/registerqueue" class="quick-link-item">
                    <b-icon icon="calendar-check-fill" class="ql-icon ql-blue"></b-icon>
                    <span>ລົງທະບຽນຈອງຄິວ</span>
                  </router-link>
                </b-col>
                <b-col cols="6" class="p-0">
                  <router-link to="/document" class="quick-link-item">
                    <b-icon icon="file-earmark-text-fill" class="ql-icon ql-red"></b-icon>
                    <span>ໃບຄຳຮ້ອງ</span>
                  </router-link>
                </b-col>
                <b-col cols="6" class="p-0">
                  <router-link to="/listqueue" class="quick-link-item">
                    <b-icon icon="list-check" class="ql-icon ql-green"></b-icon>
                    <span>ລາຍຊື່ຜູ້ລົງທະບຽນ</span>
                  </router-link>
                </b-col>
                <b-col cols="6" class="p-0">
                  <router-link to="/visadocument" class="quick-link-item">
                    <b-icon icon="card-text" class="ql-icon ql-gold"></b-icon>
                    <span>ເອກະສານວີຊ່າ</span>
                  </router-link>
                </b-col>
              </b-row>
            </div>
          </div>

        </b-col>
      </b-row>

    </b-container>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.contract-page {
  background: #f4f6fb;
  min-height: 500px;
}
.page-title-bar {
  background: #002868;
  color: #fff;
  padding: 14px 20px;
  border-radius: 8px;
  font-size: 1.05rem;
  font-weight: 700;
  border-left: 5px solid #d4af37;
  display: flex;
  align-items: center;
}

/* Contact card */
.contact-card {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.07);
  overflow: hidden;
  height: 100%;
}
.contact-card-header {
  background: #002868;
  color: #fff;
  font-weight: 700;
  font-size: 0.95rem;
  padding: 13px 18px;
  border-left: 4px solid #d4af37;
  display: flex;
  align-items: center;
}
.contact-card-body { padding: 8px 0; }
.contact-item {
  display: flex;
  align-items: flex-start;
  padding: 13px 18px;
  border-bottom: 1px solid #f0f2f7;
  gap: 14px;
}
.contact-item:last-child { border-bottom: none; }
.contact-icon-wrap {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #002868;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 0.95rem;
}
.contact-icon-green { background: #1a7340; }
.contact-icon-purple { background: #5b3b8c; }
.contact-icon-red { background: #ce1126; }
.contact-icon-teal { background: #0d6e6e; }
.contact-label {
  font-size: 0.75rem;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 2px;
}
.contact-value { font-size: 0.9rem; color: #2c3e50; }
.contact-link { color: #002868; text-decoration: none; }
.contact-link:hover { text-decoration: underline; }

/* Info card (hours, quick links) */
.info-card {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.07);
  overflow: hidden;
}
.info-card-header {
  background: #002868;
  color: #fff;
  font-weight: 700;
  font-size: 0.9rem;
  padding: 12px 16px;
  border-left: 4px solid #d4af37;
  display: flex;
  align-items: center;
}
.info-card-body { padding: 16px; }

/* Hours */
.hours-block {
  background: #f0f6ff;
  border-radius: 8px;
  padding: 14px;
  border-left: 3px solid #002868;
}
.closed-block {
  background: #fff5f5;
  border-left-color: #ce1126;
}
.hours-day-label {
  font-weight: 700;
  color: #002868;
  font-size: 0.88rem;
  margin-bottom: 6px;
}
.hours-time-label {
  font-size: 0.88rem;
  color: #333;
}
.hours-time-closed {
  font-size: 0.88rem;
  color: #ce1126;
  font-weight: 700;
}

/* Quick links */
.quick-link-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 16px;
  border-right: 1px solid #f0f2f7;
  border-bottom: 1px solid #f0f2f7;
  text-decoration: none;
  color: #2c3e50;
  font-size: 0.87rem;
  font-weight: 600;
  transition: background 0.18s, color 0.18s;
}
.quick-link-item:hover {
  background: #eaf1fb;
  color: #002868;
  text-decoration: none;
}
.ql-icon { font-size: 1.3rem; flex-shrink: 0; }
.ql-blue  { color: #002868; }
.ql-red   { color: #ce1126; }
.ql-green { color: #1a7340; }
.ql-gold  { color: #b8860b; }
</style>
